module.exports = __webpack_public_path__ + "static/img/hgdl.d81a5158.png";